import { Tooltip as ChakraTooltip, Portal, Flex } from "@chakra-ui/react";
import * as React from "react";

export interface TooltipProps extends ChakraTooltip.RootProps {
  showArrow?: boolean;
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
  content: React.ReactNode;
  contentProps?: ChakraTooltip.ContentProps;
  disabled?: boolean;
  bg?: string;
}

export const SimpleTooltip = React.forwardRef<HTMLDivElement, TooltipProps>(function Tooltip(props, ref) {
  const { showArrow, children, disabled, bg="bg", portalled = true, content, contentProps, portalRef, ...rest } = props;

  if (disabled) return children;
  return (
    <ChakraTooltip.Root {...rest} openDelay={100} closeDelay={200}>
      <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
      <Portal disabled={!portalled} container={portalRef}>
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content ref={ref} {...contentProps} bg={bg} width="800px" maxWidth={"800px"}>
            {" "}
            {showArrow && (
              <ChakraTooltip.Arrow>
                <ChakraTooltip.ArrowTip />
              </ChakraTooltip.Arrow>
            )}
            <Flex justifyContent="center" alignItems="center" height="100%">
              {content}
            </Flex>
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </Portal>
    </ChakraTooltip.Root>
  );
});
